@if (list) {
  <table-material
    id-table="exception-id-table"
    [header]="header"
    [data]="list"
    [getValue]="getData"
    [selectable]="false"
    >
  </table-material>
}
